export var customerSayInfo = {
    items: [
        {
            avatar: "/img/customers/no-avatar.jpg",
            name: "MARTA",
            title: "Metro Atlanta Regional Transit Authority",
            text: "Working with the DFC team has been a consistently positive experience. They are not only highly responsive, but they also bring a deep knowledge base and strong data organization skills that have proven to be an invaluable asset to our team. The insights and information delivered by DFC contribute directly to more efficient and proactive management of our existing infrastructure. Their work has played a key role in helping us make informed decisions and maintain operational effectiveness. Overall, DFC is a trusted partner whose expertise and dedication we greatly appreciate."
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            name: "Mike",
            title: "Building Owner",
            text: "A few years I spoke to a roofing consultant, and he told me about the RoofPro™ software. It sounded like the perfect solution.",
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            name: "USAR",
            title: "USAR NRI Roofing Program",
            text: "Over a multiple year 7+ engagement: managing 680 facilities with over 2000 buildings. Digital provided data importing of consultant reports in secure a Roof management application. Highly rated in post contact reviews for timely response and professional services."
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "RoofPro™ is great for generating five-year budget plans. We can send the budgets out electronically, or print out pretty graphics and reports and present it in person. Sometimes the hard copies tell the story better than a digital format.",
            name: "Lemka",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Finally the roof condition surveys and budget reports make accurate budgeting and planning possible. RoofPro™ software increases effectiveness while reducing costs and it is a central feature of our roofing program.",
            name: "H. Lewis",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            name: "WMU",
            title: "Western Michigan University",
            text: "WMU's campuses encompass more than 1,200 acres (4.9 km2) and roughly 150 buildings. Western is divided into five campuses near Kalamazoo Michigan. Digital has provided Roof Management service which spans multiple managers over twenty-two years of services."
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Since implementing RoofPro™, all roofing information is now stored and managed in a central database, where it can be easily accessed and updated.",
            name: "Fifelski",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "We have about 500 roofing sections stored in the system, so it is very easy to do a search on something like age and use the results to quickly produce a report on aging roofs. There is no way we could do that with paper files.",
            name: "Ken",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Features such as the ability to track and set priorities for repairs and re-roofing and maintaining warranties are very useful in managing roofing assets. The programs ability to support photographs and CAD drawings is extremely beneficial.",
            name: "Bud",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "It also saves in the “soft costs” associated with estimators, asbestos abatement professionals, and roof consultants. With RoofPro™ we can provide the consultant with data such as roof measurements, specifications, estimates, drawings we...",
            name: "Mike",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "We had numerous cooling towers on this IRMA roof and the heavy foot traffic was causing the pavers to crack and crumble and penetrate the roofing membrane. RoofPro™ helped track this problem; to determine if a different type of roof system...",
            name: "Lemka",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "With RoofPro™ it is very easy to pass information on. Co-workers can easily access information in the RoofPro™ database – such as an inspection report and photos.",
            name: "Mike",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Building the RoofPro™ database is simple, because RoofPro™ allows documents such as warranties to be filed as attachments.",
            name: "Lemka",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "RoofPro™ also lets us set up a more effective preventive maintenance program. We can easily find out what work was done and when, and when future maintenance should be scheduled, taking into account the roof’s history and warranty...",
            name: "Mike",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "By being able to access up-to-date, accurate information, we are doing a better job maintaining our roofs. Now we can use this data to focus on roofs that are in poor condition, have warranty issues, or are in a crucial, sensitive area. By...",
            name: "Fifelski",
            title: "Building Owner"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "We used to spend countless hours creating, modifying and tweaking information before we end up with a report that we were satisfied with. We’ve now reduced our production time by over 70% and changes are only a “click” away.",
            name: "Rohbock",
            title: "Consultants"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Our profitability has increased, our costs to our customers has gone down, what a great combination. Our business continues to grow in double digits and we believe this software is part of the reason.",
            name: "Rohbock",
            title: "Consultants"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Keep in mind there is a learning curve and once you get past that, you’ll never want to go back.",
            name: "Jim",
            title: "Consultants"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "RoofPro™ software allowed us to work directly with the school district on repair recommendations and timing; products were chosen that were the right fit for the job.",
            name: "Turner",
            title: "Roofing Contractors"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "From the standpoint of coatings contractors, RoofPro™ helps to determine the roofs that are the best candidates for coating systems. We have used RoofPro™ for over 10 years and have seen RoofPro™ reports lead directly to coating work.",
            name: "Randy",
            title: "Roofing Contractors"
        },
        {
            avatar: "/img/customers/no-avatar.jpg",
            text: "Digital Facilities Corporation has been very good to work with. They make a definite effort to find out what does and doesn't work, and answer our questions promptly.",
            name: "Mike",
            title: "Roofing Industry"
        }
    ]
}